import React from 'react';
import PropTypes from 'prop-types';
import { HeroBadge, PromoBadge } from 'app/commonComponents/productBadge/heroPromoBadge';
import ProductData from './productData';
import ProductImage from './productImage';

const ProductItem = ({
  product,
  hasMoreProductsPerRow,
  appendQueryToUrl,
  onClick,
  resultPosition,
  displayHeroBadge,
}) => {
  const { heroBadges = [], promoBadges = [] } = product;

  const heroBadgeElements =
    displayHeroBadge && heroBadges.length > 0 && heroBadges.map(badge => <HeroBadge key={badge} value={badge} />);
  const promoBadgeElements =
    promoBadges.length > 0 && promoBadges.map(badge => <PromoBadge key={badge} value={badge} />);

  const appendUrl = appendQueryToUrl || '';
  const { pathname, hash } = new URL(window.location.origin + product.url);

  function handleProductClick(event) {
    onClick(product, resultPosition, event);
  }

  return (
    <div className="text-center" data-sku={product.id}>
      <a className="product-link" href={pathname + appendUrl + hash} onClick={handleProductClick}>
        {heroBadgeElements && <div className="product-badge--top-left">{heroBadgeElements}</div>}
        <ProductImage product={product} hasMoreProductsPerRow={hasMoreProductsPerRow} />
        <ProductData product={product} />
        {promoBadgeElements && <div className="product-badge--bottom">{promoBadgeElements}</div>}
      </a>
    </div>
  );
};

ProductItem.defaultProps = {
  hasMoreProductsPerRow: false,
  appendQueryToUrl: '',
  displayHeroBadge: true,
};

ProductItem.propTypes = {
  product: PropTypes.objectOf(PropTypes.any).isRequired,
  hasMoreProductsPerRow: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  resultPosition: PropTypes.number.isRequired,
  appendQueryToUrl: PropTypes.string,
  displayHeroBadge: PropTypes.bool,
};

export default ProductItem;
